{
  "labels": {
    "paste": "Dán",
    "pasteAsPlaintext": "Dán kiểu văn bản thuần",
    "pasteCharts": "Dán biểu đồ",
    "selectAll": "Chọn tất cả",
    "multiSelect": "Chọn thêm đối tượng này",
    "moveCanvas": "Di chuyển canvas",
    "cut": "Cắt",
    "copy": "Sao chép",
    "copyAsPng": "Sao chép vào bộ nhớ tạm dưới dạng PNG",
    "copyAsSvg": "Sao chép vào bộ nhớ tạm dưới dạng SVG",
    "copyText": "Sao chép vào bộ nhớ tạm dưới dạng chữ",
    "copySource": "Sao chép vào bộ nhớ tạm",
    "convertToCode": "Chuyển thành mã",
    "bringForward": "Đưa ra trước",
    "sendToBack": "Hạ xuống dưới",
    "bringToFront": "Đưa ra đầu tiên",
    "sendBackward": "Hạ xuống cuối",
    "delete": "Xóa",
    "copyStyles": "Sao chép định dạng",
    "pasteStyles": "Dán định dạng",
    "stroke": "Nét",
    "changeStroke": "Đổi màu nét vẽ",
    "background": "Nền",
    "changeBackground": "Thay đổi màu nền",
    "fill": "Đổ màu",
    "strokeWidth": "Độ dày nét",
    "strokeStyle": "Kiểu nét",
    "strokeStyle_solid": "Khối",
    "strokeStyle_dashed": "Gạch ngang",
    "strokeStyle_dotted": "Nhiều chấm",
    "sloppiness": "Hoa văn nét",
    "opacity": "Độ trong suốt",
    "textAlign": "Căn chỉnh văn bản",
    "edges": "Cạnh",
    "sharp": "Nhọn",
    "round": "Tròn",
    "arrowheads": "Đầu mũi tên",
    "arrowhead_none": "Không",
    "arrowhead_arrow": "Mũi tên",
    "arrowhead_bar": "Thanh",
    "arrowhead_circle": "Hình tròn",
    "arrowhead_circle_outline": "Hình tròn (đường viền)",
    "arrowhead_triangle": "Tam giác",
    "arrowhead_triangle_outline": "Tam giác (đường viền)",
    "arrowhead_diamond": "Kim cương",
    "arrowhead_diamond_outline": "Kim cương (đường viền)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "Tùy chọn khác",
    "arrowtypes": "Loại mũi tên",
    "arrowtype_sharp": "Mũi tên nhọn",
    "arrowtype_round": "Mũi tên cong",
    "arrowtype_elbowed": "Mũi tên gấp khúc",
    "fontSize": "Cỡ chữ",
    "fontFamily": "Phông chữ",
    "addWatermark": "Làm với Excalidraw\"",
    "handDrawn": "Vẽ tay",
    "normal": "Bình thường",
    "code": "Mã",
    "small": "Nhỏ",
    "medium": "Vừa",
    "large": "Lớn",
    "veryLarge": "Rất lớn",
    "solid": "Đặc",
    "hachure": "Nét gạch gạch",
    "zigzag": "Zig-zag",
    "crossHatch": "Nét gạch chéo",
    "thin": "Mỏng",
    "bold": "In đậm",
    "left": "Trái",
    "center": "Giữa",
    "right": "Phải",
    "extraBold": "Nét siêu đậm",
    "architect": "Kiến trúc sư",
    "artist": "Nghệ sỹ",
    "cartoonist": "Hoạt hình",
    "fileTitle": "Tên tập tin",
    "colorPicker": "Chọn màu",
    "canvasColors": "Đã dùng trên canvas",
    "canvasBackground": "Nền canvas",
    "drawingCanvas": "Canvas vẽ",
    "clearCanvas": "Xóa khung vẽ",
    "layers": "Lớp",
    "actions": "Chức năng",
    "language": "Ngôn ngữ",
    "liveCollaboration": "Hợp tác trực tiếp...",
    "duplicateSelection": "Tạo bản sao",
    "untitled": "Không có tiêu đề",
    "name": "Tên",
    "yourName": "Tên của bạn",
    "madeWithExcalidraw": "Làm với Excalidraw",
    "group": "Gộp nhóm lại lựa chọn",
    "ungroup": "Tách nhóm lựa chọn",
    "collaborators": "Cộng tác viên",
    "toggleGrid": "Bật/tắt lưới",
    "addToLibrary": "Thêm vào thư viện",
    "removeFromLibrary": "Xóa khỏi thư viện",
    "libraryLoadingMessage": "Đang tải thư viện…",
    "libraries": "Xem thư viện",
    "loadingScene": "Đang tải về…",
    "loadScene": "Tải bản vẽ từ tệp",
    "align": "Căn chỉnh",
    "alignTop": "Căn trên",
    "alignBottom": "Căn dưới",
    "alignLeft": "Canh trái",
    "alignRight": "Canh phải",
    "centerVertically": "Giữa theo chiều dọc",
    "centerHorizontally": "Giữa theo chiều ngang",
    "distributeHorizontally": "Phân bố theo chiều ngang",
    "distributeVertically": "Phân bố theo chiều dọc",
    "flipHorizontal": "Lật ngang",
    "flipVertical": "Lật dọc",
    "viewMode": "Chế độ xem",
    "share": "Chia sẻ",
    "showStroke": "Hiển thị chọn màu",
    "showBackground": "Hiện thị chọn màu nền",
    "showFonts": "Hiển thị bộ chọn phông chữ",
    "toggleTheme": "Chuyển đổi giao diện sáng/tối",
    "theme": "Chủ đề",
    "personalLib": "Thư viện cá nhân",
    "excalidrawLib": "Thư viện Excalidraw",
    "decreaseFontSize": "Giảm cỡ chữ",
    "increaseFontSize": "Tăng cỡ chữ",
    "unbindText": "Bỏ liên kết văn bản",
    "bindText": "Gắn văn bản vào khung",
    "createContainerFromText": "Ngắt dòng văn bản trong khung",
    "link": {
      "edit": "Sửa liên kết",
      "editEmbed": "Chỉnh sửa liên kết nhúng",
      "create": "Thêm liên kết",
      "label": "Liên kết",
      "labelEmbed": "Liên kết & nhúng",
      "empty": "Chưa đặt liên kết",
      "hint": "Nhập hoặc dán liên kết vào đây",
      "goToElement": "Đi tới phần tử đích"
    },
    "lineEditor": {
      "edit": "Điều chỉnh nét",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Khoá",
      "unlock": "Mở khoá",
      "lockAll": "Khóa tất cả",
      "unlockAll": "Mở khóa tất cả"
    },
    "statusPublished": "Đã đăng tải",
    "sidebarLock": "Giữ thanh bên luôn mở",
    "selectAllElementsInFrame": "Chọn tất cả phần tử trong khung",
    "removeAllElementsFromFrame": "Loại bỏ tất cả các phần tử trong khung",
    "eyeDropper": "Chọn màu từ vùng vẽ",
    "textToDiagram": "Văn bản sang sơ đồ",
    "prompt": "Lời nhắc",
    "followUs": "Theo dõi chúng tôi",
    "discordChat": "Trò chuyện Discord",
    "zoomToFitViewport": "Thu phóng vừa với khung nhìn",
    "zoomToFitSelection": "Thu phóng vừa với vùng chọn",
    "zoomToFit": "Thu phóng để hiển thị toàn bộ các phần tử",
    "installPWA": "Cài đặt Excalidraw trên máy (PWA)",
    "autoResize": "Bật tự động thay đổi kích thước văn bản",
    "imageCropping": "Cắt ảnh",
    "unCroppedDimension": "Kích thước gốc (chưa cắt)",
    "copyElementLink": "Sao chép liên kết tới đối tượng",
    "linkToElement": "Liên kết đến đối tượng",
    "wrapSelectionInFrame": "Đưa vùng chọn vào khung",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "Liên kết đến đối tượng",
    "desc": "Nhấp vào một hình trên vùng vẽ hoặc dán liên kết.",
    "notFound": "Không tìm thấy đối tượng liên kết trên vùng vẽ."
  },
  "library": {
    "noItems": "Chưa có món nào...",
    "hint_emptyLibrary": "Chọn một món trên canvas để thêm nó vào đây, hoặc cài đặt thư viện từ kho lưu trữ công cộng, ở bên dưới.",
    "hint_emptyPrivateLibrary": "Chọn một món trên canvas để thêm nó vào đây.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "Tìm trên vùng vẽ",
    "noMatch": "Không có kết quả phù hợp...",
    "singleResult": "kết quả",
    "multipleResults": "các kết quả",
    "placeholder": "Tìm văn bản trên vùng vẽ",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Reset canvas",
    "exportJSON": "Xuất ra tập tin",
    "exportImage": "Xuất file ảnh...",
    "export": "Lưu vào...",
    "copyToClipboard": "Sao chép vào bộ nhớ tạm",
    "copyLink": "Sao chép liên kết",
    "save": "Lưu vào tập tin hiện tại",
    "saveAs": "Lưu thành",
    "load": "Mở",
    "getShareableLink": "Tạo liên kết để chia sẻ",
    "close": "Đóng",
    "selectLanguage": "Chọn ngôn ngữ",
    "scrollBackToContent": "Cuộn về nội dung chính",
    "zoomIn": "Phóng to",
    "zoomOut": "Thu nhỏ",
    "resetZoom": "Đặt lại thu phóng",
    "menu": "Bảng chọn",
    "done": "Xong",
    "edit": "Chỉnh sửa",
    "undo": "Hoàn tác",
    "redo": "Làm lại",
    "resetLibrary": "Cài lại thư viện",
    "createNewRoom": "Tạo phòng mới",
    "fullScreen": "Toàn màn hình",
    "darkMode": "Chế độ tối",
    "lightMode": "Chế độ sáng",
    "systemMode": "Chế độ hệ thống",
    "zenMode": "Chế độ zen",
    "objectsSnapMode": "Căn chỉnh theo đối tượng",
    "exitZenMode": "Thoát chể độ zen",
    "cancel": "Hủy",
    "saveLibNames": "",
    "clear": "Làm sạch",
    "remove": "Xóa",
    "embed": "Bật/tắt chế độ nhúng",
    "publishLibrary": "",
    "submit": "Gửi",
    "confirm": "Xác nhận",
    "embeddableInteractionButton": "Nhấn để tương tác"
  },
  "alerts": {
    "clearReset": "Điều này sẽ dọn hết canvas. Bạn có chắc không?",
    "couldNotCreateShareableLink": "Không thể tạo đường dẫn chia sẻ.",
    "couldNotCreateShareableLinkTooBig": "Không thể tạo đường dẫn chia sẻ: bản vẽ quá lớn",
    "couldNotLoadInvalidFile": "Không thể load tập tin không hợp lệ",
    "importBackendFailed": "Nhập dữ liệu từ máy chủ thất bại.",
    "cannotExportEmptyCanvas": "Không thể xuất canvas trống.",
    "couldNotCopyToClipboard": "Không thể sao chép vào bộ nhớ tạm.",
    "decryptFailed": "Không thể giải mã dữ liệu.",
    "uploadedSecurly": "Việc tải lên đã được bảo mật với mã hóa đầu cuối, có nghĩa là máy chủ Excalidraw và bên thứ ba không thể đọc nội dung.",
    "loadSceneOverridePrompt": "Mở bản vẽ bên ngoài sẽ thay thế nội dung hiện tại của bạn. Bạn có muốn tiếp tục không?",
    "collabStopOverridePrompt": "Dừng phiên sẽ ghi đè lên bản vẽ được lưu trữ cục bộ trước đó của bạn. Bạn có chắc không?\n\n(Nếu bạn muốn giữ bản vẽ cục bộ của mình, chỉ cần đóng tab trình duyệt.)",
    "errorAddingToLibrary": "Không thể thêm món vào thư viện",
    "errorRemovingFromLibrary": "Không thể xoá món khỏi thư viện",
    "confirmAddLibrary": "Hình {{numShapes}} sẽ được thêm vào thư viện. Bạn chắc chứ?",
    "imageDoesNotContainScene": "Hình ảnh này dường như không chứa bất kỳ dữ liệu cảnh nào. Bạn đã bật tính năng nhúng cảnh khi xuất chưa?",
    "cannotRestoreFromImage": "Không thể khôi phục bản vẽ từ tệp hình ảnh này.",
    "invalidSceneUrl": "Không thể nhập nội dung từ URL đã cung cấp. Đó có thể là do URL không đúng cú pháp hoặc không chứa dữ liệu JSON hợp lệ với Excalidraw.",
    "resetLibrary": "Hành động này sẽ xóa toàn bộ thư viện của bạn. Bạn chắc chắn chứ?",
    "removeItemsFromsLibrary": "Xoá {{count}} món từ thư viện?",
    "invalidEncryptionKey": "Khóa mã hóa phải có 22 ký tự. Hợp tác trực tiếp bị vô hiệu hóa.",
    "collabOfflineWarning": "Không có kết nối internet.\nThay đổi của bạn sẽ không được lưu!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Loại tập tin không được hỗ trợ.",
    "imageInsertError": "Không thể thêm ảnh. Hãy thử lại sau...",
    "fileTooBig": "Tệp tin quá lớn. Dung lượng tối đa cho phép là {{maxSize}}.",
    "svgImageInsertError": "Không thể thêm ảnh SVG. Mã SVG có vẻ sai.",
    "failedToFetchImage": "Có lỗi khi tải ảnh.",
    "cannotResolveCollabServer": "Không thể kết nối với máy chủ hợp tác. Hãy tải lại trang và thử lại.",
    "importLibraryError": "Không thể tải thư viện",
    "saveLibraryError": "Không thể lưu thư viện vào bộ nhớ. Hãy lưu thành tệp trên máy để đảm bảo bạn không mất các thay đổi.",
    "collabSaveFailed": "Không thể lưu vào cơ sở dữ liệu. Nếu vấn đề tiếp tục xảy ra, bạn nên lưu tệp vào máy để đảm bảo bạn không bị mất công việc.",
    "collabSaveFailed_sizeExceeded": "Không thể lưu vào cơ sở dữ liệu, canvas có vẻ quá lớn. Bạn nên lưu tệp cục bộ để đảm bảo bạn không bị mất công việc.",
    "imageToolNotSupported": "Hình ảnh đã được vô hiệu hóa.",
    "brave_measure_text_error": {
      "line1": "Dường như bạn đang sử dụng trình duyệt Brave với cài đặt <bold>Aggressively Block Fingerprinting</bold> được bật.",
      "line2": "Điều này có thể gây ra lỗi cho các <bold>Text Elements</bold> trong bản vẽ của bạn.",
      "line3": "Chúng tôi khuyên bạn nên tắt tùy chọn này. Xem <link>hướng dẫn này</link> để biết cách thực hiện.",
      "line4": "Nếu tắt cài đặt này vẫn không sửa được lỗi hiển thị chữ, hãy tạo <issueLink>báo cáo lỗi</issueLink> trên GitHub hoặc liên hệ qua <discordLink>Discord</discordLink>."
    },
    "libraryElementTypeError": {
      "embeddable": "Không thể lưu phần tử nhúng vào thư viện",
      "iframe": "Các phần tử IFrame không thể được thêm vào thư viện.",
      "image": "Thêm hình ảnh vào thư viện sẽ sớm được hỗ trợ!"
    },
    "asyncPasteFailedOnRead": "Không thể dán (không thể đọc từ bộ nhớ tạm của hệ thống).",
    "asyncPasteFailedOnParse": "Không thể dán.",
    "copyToSystemClipboardFailed": "Không thể sao chép vào bộ nhớ tạm."
  },
  "toolBar": {
    "selection": "Lựa chọn",
    "lasso": "",
    "image": "Chèn ảnh",
    "rectangle": "Hình chữ nhật",
    "diamond": "Kim cương",
    "ellipse": "Hình elíp",
    "arrow": "Mũi tên",
    "line": "Đường kẻ",
    "freedraw": "Vẽ",
    "text": "Văn bản",
    "library": "Thư viện",
    "lock": "Giữ dụng cũ hiện tại sau khi vẽ",
    "penMode": "Chế độ bút vẽ - ngăn ngừa chạm nhầm",
    "link": "Thêm / Cập nhật liên kết cho hình đã chọn",
    "eraser": "Xóa",
    "frame": "Công cụ tạo khung",
    "magicframe": "Wireframe thành code",
    "embeddable": "Nhúng Web",
    "laser": "Con trỏ laser",
    "hand": "Tay kéo",
    "extraTools": "Công cụ khác",
    "mermaidToExcalidraw": "Mermaid sang Excalidraw",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "Hình chữ nhật",
    "diamond": "Kim cương",
    "ellipse": "Hình bầu dục",
    "arrow": "Mũi tên",
    "line": "Đường kẻ",
    "freedraw": "Vẽ tự do",
    "text": "Văn bản",
    "image": "Hình ảnh",
    "group": "Nhóm",
    "frame": "Khung hình",
    "magicframe": "Wireframe thành code",
    "embeddable": "Nhúng Web",
    "selection": "Lựa chọn",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Hành động canvas",
    "selectedShapeActions": "Các hành động cho hình dạng đã chọn",
    "shapes": "Các hình khối"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Ấn để bắt đầu nhiểm điểm vẽ, kéo để vẽ một đường thẳng",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Ấn bà kéo, thả khi bạn xong",
    "text": "Mẹo: bạn có thể thêm văn bản tại bất cứ đâu bằng cách ấn hai lần bằng tool lựa chọn",
    "embeddable": "Nhấp và kéo để tạo nội dung nhúng từ website.",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "Giới hạn góc độ bằng cách giữ {{shortcut}} khi xoay",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Chia sẻ thư viện của bạn",
    "bindTextToElement": "Nhấn {{shortcut}} để thêm văn bản",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Tính năng này có thể được bật bằng cách đặt cờ \"dom.events.asyncClipboard.clipboardItem\" thành \"true\". Để thay đổi cờ trình duyệt trong Firefox, hãy truy cập trang \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Không thể xem trước",
    "canvasTooBig": "Canvas này có thể hơi lớn.",
    "canvasTooBigTip": "Mẹo: hãy thử di chuyển các elements nhất lại gần nhau hơn một chút."
  },
  "errorSplash": {
    "headingMain": "Đã xảy ra lỗi. Hãy thử <button>tải lại trang</button>.",
    "clearCanvasMessage": "Nếu không tải lại được, hãy thử <button>dọn canvas.</button>",
    "clearCanvasCaveat": " Điều này sẽ dẫn đến mất dữ liệu bạn đã làm ",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": "Nội dung bản vẽ:"
  },
  "shareDialog": {
    "or": "Hoặc"
  },
  "roomDialog": {
    "desc_intro": "Mời mọi người cùng cộng tác trong bản vẽ của bạn.",
    "desc_privacy": "Đừng lo, phiên hoạt động đã được mã hóa đầu cuối, và hoàn toàn riêng tư. Ngay cả máy chủ của chúng tôi cũng không thể thấy những gì bạn vẽ.",
    "button_startSession": "Bắt đầu phiên",
    "button_stopSession": "Kết thúc phiên",
    "desc_inProgressIntro": "Phiên làm việc trực tiếp hiện đang diễn ra.",
    "desc_shareLink": "Chia sẻ liên kết này với người bạn muốn cộng tác cùng:",
    "desc_exitSession": "Dừng phiên sẽ đưa bạn ra khỏi phòng, nhưng bạn vẫn có thể làm việc tiếp trên máy. Những người khác sẽ không bị ảnh hưởng và vẫn cộng tác trên bản của họ.",
    "shareTitle": "Vào phiên làm việc chung trên Excalidraw"
  },
  "errorDialog": {
    "title": "Lỗi"
  },
  "exportDialog": {
    "disk_title": "Lưu về máy",
    "disk_details": "",
    "disk_button": "Lưu vào tệp tin",
    "link_title": "Liên kết có thể chia sẻ",
    "link_details": "Tạo liên kết chỉ xem",
    "link_button": "Tạo liên kết",
    "excalidrawplus_description": "Lưu bản vẽ vào không gian làm việc Excalidraw+ của bạn.",
    "excalidrawplus_button": "Xuất",
    "excalidrawplus_exportError": "Hiện tại không thể xuất sang Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Đọc blog của chúng tôi",
    "click": "Nhấp",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Mũi tên cong",
    "curvedLine": "Đường cong",
    "documentation": "Tài liệu",
    "doubleClick": "Nhấp đúp",
    "drag": "kéo",
    "editor": "Trình chỉnh sửa",
    "editLineArrowPoints": "Chỉnh sửa điểm của đường/mũi tên",
    "editText": "Chỉnh sửa văn bản / thêm nhãn",
    "github": "Phát hiện lỗi? Gửi phản hồi",
    "howto": "Làm theo hướng dẫn của chúng tôi",
    "or": "hoặc",
    "preventBinding": "Ngăn mũi tên tự gắn",
    "tools": "Công cụ",
    "shortcuts": "Phím tắt bàn phím",
    "textFinish": "Hoàn tất chỉnh sửa (trình soạn thảo văn bản)",
    "textNewLine": "",
    "title": "Trợ giúp",
    "view": "Xem",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "Khóa/mở khóa vùng lựa chọn",
    "movePageUpDown": "Chuyển trang lên/xuống",
    "movePageLeftRight": "Chuyển trang trái/phải",
    "cropStart": "Cắt ảnh",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Dọn canvas"
  },
  "publishDialog": {
    "title": "",
    "itemName": "Tên món",
    "authorName": "Tên tác giả",
    "githubUsername": "Tên tài khoản Github",
    "twitterUsername": "Tên tài khoản Twitter",
    "libraryName": "Tên thư viện",
    "libraryDesc": "Mô tả thư viện",
    "website": "Website",
    "placeholder": {
      "authorName": "Tên của bạn hoặc tên tài khoản",
      "libraryName": "Tên thư viện của bạn",
      "libraryDesc": "Mô tả thư viện của bạn để mọi người có thể hiểu được cách dùng của nó",
      "githubHandle": "",
      "twitterHandle": "Tên Twitter (không bắt buộc) để chúng tôi ghi nhận bạn khi chia sẻ trên Twitter.",
      "website": "Đường dẫn tới trang web cá nhân của bạn hoặc tới đâu đó (tùy chọn)"
    },
    "errors": {
      "required": "Bắt buộc",
      "website": "Nhập đường dẫn hợp lệ"
    },
    "noteDescription": "Chia sẻ thư viện của bạn vào <link>kho thư viện công khai</link> để mọi người có thể dùng trong bản vẽ của họ.",
    "noteGuidelines": "Thư viện cần được phê duyệt thủ công trước. Vui lòng đọc <link>hướng dẫn</link> trước khi gửi. Bạn sẽ cần tài khoản GitHub để trao đổi và chỉnh sửa khi được yêu cầu, nhưng điều này không bắt buộc.",
    "noteLicense": "Bằng việc gửi, bạn đồng ý rằng thư viện sẽ được phát hành theo <link>Giấy phép MIT</link>, nghĩa là bất kỳ ai cũng có thể sử dụng mà không bị hạn chế.",
    "noteItems": "Từng món trong thư viện phải có tên riêng để có thể lọc. Các món thư viện sau đây sẽ thêm:",
    "atleastOneLibItem": "Vui lòng chọn ít nhất một món thư viện để bắt đầu",
    "republishWarning": "Lưu ý: một số món đã chọn được đánh dấu là đã xuất bản/đã gửi. Bạn chỉ nên gửi lại các món khi cập nhật thư viện hiện có hoặc gửi."
  },
  "publishSuccessDialog": {
    "title": "Thư viện đã được gửi",
    "content": "Cảm ơn {{authorName}}! Thư viện của bạn đã được gửi để duyệt. Bạn có thể xem tiến trình <link>tại đây</link>."
  },
  "confirmDialog": {
    "resetLibrary": "Cài lại thư viện",
    "removeItemsFromLib": "Xóa món đã chọn khỏi thư viện"
  },
  "imageExportDialog": {
    "header": "Xuất thành hình ảnh",
    "label": {
      "withBackground": "Nền",
      "onlySelected": "Chỉ phần tử đã lựa chọn",
      "darkMode": "Chế độ tối",
      "embedScene": "",
      "scale": "Thu phóng",
      "padding": "Phần đệm"
    },
    "tooltip": {
      "embedScene": "Dữ liệu của bối cảnh sẽ được lưu dưới định dạng PNG/SVG vậy nên bối cảnh có thể khôi phục lại từ nó.\nSẽ tăng kích thước của tệp được lưu."
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": "Sao chép PNG vào bộ nhớ"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Sao chép vào bộ nhớ tạm"
    }
  },
  "encrypted": {
    "tooltip": "Bản vẽ của bạn được bảo mật bằng mã hóa đầu cuối, vì vậy máy chủ Excalidraw sẽ không thể xem chúng.",
    "link": "Bài blog về mã hóa đầu cuối trong Excalidraw"
  },
  "stats": {
    "angle": "Góc",
    "shapes": "",
    "height": "Chiều cao",
    "scene": "Bối cảnh",
    "selected": "Đã chọn",
    "storage": "Bộ nhớ",
    "fullTitle": "",
    "title": "Thuộc tính",
    "generalStats": "Chung",
    "elementProperties": "",
    "total": "Tổng cộng",
    "version": "Phiên bản",
    "versionCopy": "Nhấn để sao chép",
    "versionNotAvailable": "Phiên bản không khả dụng",
    "width": "Chiều rộng"
  },
  "toast": {
    "addedToLibrary": "Đã thêm vào Thư viện",
    "copyStyles": "Đã sao chép định dạng.",
    "copyToClipboard": "Đã sao chép vào bộ nhớ tạm.",
    "copyToClipboardAsPng": "Đã sao chép {{exportSelection}} sang bộ nhớ tạm dưới định dạng PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "Đã sao chép {{exportSelection}} sang bộ nhớ tạm dưới định dạng SVG\n({{exportColorScheme}})",
    "fileSaved": "Đã lưu tập tin",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "lựa chọn",
    "pasteAsSingleElement": "Sử dụng {{shortcut}} để dán như một phần tử riêng lẻ hoặc dán vào một bộ soạn thảo văn bản có sẵn",
    "unableToEmbed": "Nhúng liên kết này hiện không được phép. Đưa ra vấn đề trên GitHub để yêu cầu đưa liên kết này vào danh sách được phép",
    "unrecognizedLinkFormat": "Liên kết bạn nhúng không khớp với định dạng mong đợi. Vui lòng thử dán liên kết 'embed' do trang nguồn cung cấp",
    "elementLinkCopied": "Đã sao chép liên kết vào bộ nhớ tạm"
  },
  "colors": {
    "transparent": "Độ trong suốt",
    "black": "Màu đen",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "Màu xanh lục",
    "green": "Màu xanh lá",
    "yellow": "Màu vàng",
    "orange": "Màu cam",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
